// Centralized route mappings for all languages
// This file provides consistent URL generation across the application

export const routeMappings = {
  sv: {
    home: '/',
    login: '/logga-in',
    register: '/registrera',
    pricing: '/priser',
    assistant: '/ai-assistent',
    lessons: '/teorilektioner',
    tests: '/teoriprov',
    trafficSigns: '/trafikmarken',
    quickTips: '/snabba-rad',
    interactiveMap: '/interaktiv-karta',
    importantWords: '/viktiga-ord',
    trafficRules: '/trafikregler',
    howToUse: '/hur-man-anvander',
    support: '/support',
    dashboard: '/oversikt',
    settings: '/installningar',
    adminPanel: '/admin-panel',
    privacy: '/integritet',
    terms: '/villkor',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/glomt-losenord',
    speedChallenge: '/utmaning',
  },
  en: {
    home: '/en',
    login: '/en/login',
    register: '/en/register',
    pricing: '/en/pricing',
    assistant: '/en/assistant',
    lessons: '/en/lessons',
    tests: '/en/tests',
    trafficSigns: '/en/traffic-signs',
    quickTips: '/en/quick-tips',
    interactiveMap: '/en/interactive-map',
    importantWords: '/en/important-words',
    trafficRules: '/en/traffic-rules',
    howToUse: '/en/how-to-use',
    support: '/en/support',
    dashboard: '/en/dashboard',
    settings: '/en/settings',
    adminPanel: '/admin-panel',
    privacy: '/en/privacy',
    terms: '/en/terms',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/en/forgot-password',
    speedChallenge: '/en/speed-challenge',
  },
  ar: {
    home: '/ar',
    login: '/ar/tsjeel-dkhool',
    register: '/ar/inshaa-hsab',
    pricing: '/ar/alasaar',
    assistant: '/ar/almosaed',
    lessons: '/ar/doross',
    tests: '/ar/ikhtibarat',
    trafficSigns: '/ar/isharat-almroor',
    quickTips: '/ar/nasaeh-sareea',
    interactiveMap: '/ar/alkharita-altafaeulia',
    importantWords: '/ar/kalimat-hama',
    trafficRules: '/ar/qawanin-almroor',
    howToUse: '/ar/tariqat-alistkhdam',
    support: '/ar/daem',
    dashboard: '/ar/lawhat-altahkum',
    settings: '/ar/aladaadaat',
    adminPanel: '/admin-panel',
    privacy: '/ar/alkhsosiya',
    terms: '/ar/alshroot',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/ar/nseet-klmat-almroor',
    speedChallenge: '/ar/tahadi',
  },
  tr: {
    home: '/tr',
    login: '/tr/giris',
    register: '/tr/kayit',
    pricing: '/tr/fiyatlar',
    assistant: '/tr/asistan',
    lessons: '/tr/dersler',
    tests: '/tr/testler',
    trafficSigns: '/tr/trafik-isaretleri',
    quickTips: '/tr/hizli-ipuclari',
    interactiveMap: '/tr/etkilesimli-harita',
    importantWords: '/tr/onemli-kelimeler',
    trafficRules: '/tr/trafik-kurallari',
    howToUse: '/tr/nasil-kullanilir',
    support: '/tr/destek',
    dashboard: '/tr/kontrol-paneli',
    settings: '/tr/ayarlar',
    adminPanel: '/admin-panel',
    privacy: '/tr/gizlilik',
    terms: '/tr/sartlar',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/tr/sifremi-unuttum',
    speedChallenge: '/tr/hiz-yarismasi',
  },
  fa: {
    home: '/fa',
    login: '/fa/vorod',
    register: '/fa/sabt-nam',
    pricing: '/fa/gheymat-ha',
    assistant: '/fa/dastiar',
    lessons: '/fa/dars-ha',
    tests: '/fa/azmoon-ha',
    trafficSigns: '/fa/alamat-rahnamaii',
    quickTips: '/fa/nookat-sari',
    interactiveMap: '/fa/naghshe-taamoli',
    importantWords: '/fa/kalamaat-mohem',
    trafficRules: '/fa/qavanin-rahnamai',
    howToUse: '/fa/rahnamaye-estefade',
    support: '/fa/poshtibani',
    dashboard: '/fa/panel-karbar',
    settings: '/fa/tanzimaat',
    adminPanel: '/admin-panel',
    privacy: '/fa/harim-khososi',
    terms: '/fa/sharayet',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/fa/faramoshi-ramz',
    speedChallenge: '/fa/chalesh',
  },
  so: {
    home: '/so',
    login: '/so/gal',
    register: '/so/diiwaangeli',
    pricing: '/so/qiimaha',
    assistant: '/so/kaaliye',
    lessons: '/so/casharada',
    tests: '/so/imtixaanada',
    trafficSigns: '/so/calaamadaha-taraafikada',
    quickTips: '/so/talooyinka-degdegga',
    interactiveMap: '/so/khariidad-isdhexgal',
    importantWords: '/so/erayada-muhiimka',
    trafficRules: '/so/xeerarka-taraafikada',
    howToUse: '/so/sida-loo-isticmaalo',
    support: '/so/taageero',
    dashboard: '/so/guddiga',
    settings: '/so/dejinta',
    adminPanel: '/admin-panel',
    privacy: '/so/sirta',
    terms: '/so/shuruudaha',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/so/ilowday-furaha',
    speedChallenge: '/so/tartanka',
  },
  de: {
    home: '/de',
    login: '/de/anmelden',
    register: '/de/registrieren',
    pricing: '/de/preise',
    assistant: '/de/assistent',
    lessons: '/de/lektionen',
    tests: '/de/tests',
    trafficSigns: '/de/verkehrszeichen',
    quickTips: '/de/schnelle-tipps',
    interactiveMap: '/de/interaktive-karte',
    importantWords: '/de/wichtige-worter',
    trafficRules: '/de/verkehrsregeln',
    howToUse: '/de/anleitung',
    support: '/de/support',
    dashboard: '/de/dashboard',
    settings: '/de/einstellungen',
    adminPanel: '/admin-panel',
    privacy: '/de/datenschutz',
    terms: '/de/bedingungen',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/de/passwort-vergessen',
    speedChallenge: '/de/herausforderung',
  },
  es: {
    home: '/es',
    login: '/es/iniciar-sesion',
    register: '/es/registrarse',
    pricing: '/es/precios',
    assistant: '/es/asistente',
    lessons: '/es/lecciones',
    tests: '/es/examenes',
    trafficSigns: '/es/senales-trafico',
    quickTips: '/es/consejos-rapidos',
    interactiveMap: '/es/mapa-interactivo',
    importantWords: '/es/palabras-importantes',
    trafficRules: '/es/normas-trafico',
    howToUse: '/es/como-usar',
    support: '/es/soporte',
    dashboard: '/es/panel',
    settings: '/es/configuracion',
    adminPanel: '/admin-panel',
    privacy: '/es/privacidad',
    terms: '/es/terminos',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/es/olvide-contrasena',
    speedChallenge: '/es/desafio',
  },
  pl: {
    home: '/pl',
    login: '/pl/logowanie',
    register: '/pl/rejestracja',
    pricing: '/pl/cennik',
    assistant: '/pl/asystent',
    lessons: '/pl/lekcje',
    tests: '/pl/testy',
    trafficSigns: '/pl/znaki-drogowe',
    quickTips: '/pl/szybkie-porady',
    interactiveMap: '/pl/mapa-interaktywna',
    importantWords: '/pl/wazne-slowa',
    trafficRules: '/pl/przepisy-drogowe',
    howToUse: '/pl/jak-korzystac',
    support: '/pl/wsparcie',
    dashboard: '/pl/panel',
    settings: '/pl/ustawienia',
    adminPanel: '/admin-panel',
    privacy: '/pl/prywatnosc',
    terms: '/pl/regulamin',
    paymentSuccess: '/betalning/lyckades',
    verifyEmail: '/verifiera-epost',
    forgotPassword: '/pl/zapomnialem-hasla',
    speedChallenge: '/pl/wyzwanie',
  },
};

// Swedish base path to route key mapping
export const basePathToKey = {
  '/': 'home',
  '/logga-in': 'login',
  '/registrera': 'register',
  '/priser': 'pricing',
  '/ai-assistent': 'assistant',
  '/teorilektioner': 'lessons',
  '/teoriprov': 'tests',
  '/trafikmarken': 'trafficSigns',
  '/snabba-rad': 'quickTips',
  '/interaktiv-karta': 'interactiveMap',
  '/viktiga-ord': 'importantWords',
  '/trafikregler': 'trafficRules',
  '/hur-man-anvander': 'howToUse',
  '/support': 'support',
  '/oversikt': 'dashboard',
  '/installningar': 'settings',
  '/admin-panel': 'adminPanel',
  '/integritet': 'privacy',
  '/villkor': 'terms',
  '/betalning/lyckades': 'paymentSuccess',
  '/verifiera-epost': 'verifyEmail',
  '/glomt-losenord': 'forgotPassword',
  '/utmaning': 'speedChallenge',
  // Alternative paths
  '/lessons': 'lessons',
  '/tests': 'tests',
  '/assistant': 'assistant',
  '/dashboard': 'dashboard',
};

// Get localized path for a given Swedish base path
export const getLocalizedPath = (basePath, currentLang) => {
  const routes = routeMappings[currentLang] || routeMappings['sv'];
  const routeKey = basePathToKey[basePath];
  
  if (routeKey && routes[routeKey]) {
    return routes[routeKey];
  }
  
  // Fallback to original path
  return basePath;
};

// Detect current route key from any language path
export const getRouteKeyFromPath = (path) => {
  let bestMatch = null;
  let bestLength = 0;

  for (const [lang, routes] of Object.entries(routeMappings)) {
    for (const [key, routePath] of Object.entries(routes)) {
      if (path === routePath || path.startsWith(routePath + '/')) {
        if (routePath.length > bestLength) {
          bestLength = routePath.length;
          bestMatch = key;
        }
      }
    }
  }
  return bestMatch;
};

// Get the equivalent path in another language
export const switchLanguagePath = (currentPath, newLang) => {
  // أولاً: حاول إيجاد المسار الكامل
  const routeKey = getRouteKeyFromPath(currentPath);
  
  if (routeKey && routeMappings[newLang] && routeMappings[newLang][routeKey]) {
    return routeMappings[newLang][routeKey];
  }
  
  // ثانياً: إذا كان المسار يحتوي على معرف (مثل /teoriprov/123)
  // حاول استخراج المسار الأساسي
  const pathParts = currentPath.split('/').filter(p => p);
  
  // تحقق من كل جزء من المسار
  for (let i = pathParts.length; i > 0; i--) {
    const testPath = '/' + pathParts.slice(0, i).join('/');
    const testKey = getRouteKeyFromPath(testPath);
    
    if (testKey && routeMappings[newLang] && routeMappings[newLang][testKey]) {
      // أعد بناء المسار مع الأجزاء المتبقية
      const remainingParts = pathParts.slice(i);
      const newBasePath = routeMappings[newLang][testKey];
      
      if (remainingParts.length > 0) {
        return newBasePath + '/' + remainingParts.join('/');
      }
      return newBasePath;
    }
  }
  
  // Default to home for the new language
  return routeMappings[newLang]?.home || '/';
};
